import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 1
  },
  mutations: {
    add(state) {
      // 变更状态
      state.count++
    },
    cut(state) {
      // 变更状态
      state.count--
    }
  },
  actions: {
    addAction(context) {
      context.commit('add')
    },
    cutAction(context) {
      context.commit('cut')
    }
  }
})
